import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.element.addEventListener('click', event => this.onClick(event));
    }

    onClick() {
        document.body.querySelectorAll('.dashboard-nav-item').forEach(node => node.classList.remove('active'));
        this.element.classList.add('active');
        this.element.parentNode.classList.add('active');
    }
}
